import { render, staticRenderFns } from "./reductionActivity.vue?vue&type=template&id=e2e7c51a&scoped=true"
import script from "./reductionActivity.vue?vue&type=script&lang=js"
export * from "./reductionActivity.vue?vue&type=script&lang=js"
import style0 from "./reductionActivity.vue?vue&type=style&index=0&id=e2e7c51a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e7c51a",
  null
  
)

export default component.exports